<template>
  <div class="sct">
    <TopHead name="购物咨询" />
    <!--问题-->
    <div class="que">
      <div class="d_f ali_c sct_q">
        <img
          src="../assets/img/sct_q.png"
          alt=""
        >
        <span v-if="$route.query.type == 1">景区咨询</span>
        <span v-if="$route.query.type == 2">美食咨询</span>
        <span v-if="$route.query.type == 3">酒店咨询</span>
        <span v-if="$route.query.type == 4">购物咨询</span>
        <span class="flex_1 t_r">{{ info.consultDate }}</span>
      </div>
      <div class="ans">
        {{ info.content }}
      </div>
    </div>
    <!--时间-->
    <div class="t_a">
      {{ info.replyDate }}
    </div>
    <!--回答-->
    <div class="act_ans d_f">
      <img
        src="../assets/img/sct_kefu.png"
        alt=""
      >
      <div>
        <div>{{ info.replyContent || '暂无回复' }}</div>
        <!--<div class="d_f ali_c j_s">
          <span>点击链接跳转到免税专区</span>
          <img src="../assets/img/sct_right.png" alt="">
        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ShoppingConsultation",
    data() {
      return {
        info:{},
      }
    },
    created(){
      this.getConsultsDetail()
    },
    methods: {
      getConsultsDetail(){
        this.$api.getConsultsDetail({consultId:this.$route.query.id}).then(res => {
          this.info = res.data;
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .act_ans{
    >div{
      >.d_f{
        img{
          height: 19px;
          width: 10px;
        }
        font-size: 26px;
        font-weight: bold;
        color: #2C9EF4;
        border-top: 1PX solid #c0c0c0;
        height: 69px;
        margin-top: 29px;
      }
      font-size: 24px;
      font-weight: bold;
      color: #3E3E3E;
      padding: 26px 32px 20px 55px;
      /*padding: 26px 32px 0 55px;*/
      background: #FFFFFF;
      border-radius: 0px 20px 20px 20px;
    }
    >img{
      width: 100px;
      height: 101px;
      margin-right: 36px;
    }
  }
  .que{
    .ans{
      padding: 34px 30px 40px;
      font-size: 32px;
      font-weight: bold;
      color: #3E3E3E;
    }
    .sct_q{
      .flex_1{
        font-size: 26px;
        font-weight: bold;
        color: #8E8E8E;
      }
      img{
        width: 34px;
        margin-right: 24px;
      }
      font-size: 32px;
      font-weight: bold;
      color: #3E3E3E;
      height: 68px;
      padding: 0 30px;
      background-color: #E5E5E5;
    }
    overflow: hidden;
    background: #FFFFFF;
    border-radius: 20px;
    margin-bottom: 120px;
  }
  .sct{
    >.t_a{
      margin-bottom: 34px;
      font-size: 26px;
      font-weight: bold;
      color: #808080;
    }
    height: 100vh;
    background-color: #f5f5f5;
    overflow: auto;
    box-sizing: border-box;
    padding: 180px 25px 25px;
  }

</style>
